// extracted by mini-css-extract-plugin
export default {"container":"ContentAboutUsFully_container__Euaqq","blockForBtns":"ContentAboutUsFully_blockForBtns__ke0qu"};